// Presentation/persistence tolerance for old malformed AI feedback. Never
// stringify unknown objects or pretend that lost model text can be recovered.
export const UNAVAILABLE_FEEDBACK_TEXT = 'Feedback text unavailable.';
export const UNAVAILABLE_FEEDBACK_NOTICE = 'Some AI feedback text could not be displayed. Your essay and any marks are unchanged.';

export function feedbackText(value) {
    if (typeof value !== 'string') return '';
    const text = value.trim();
    return /\[object Object\]/i.test(text) || text === UNAVAILABLE_FEEDBACK_TEXT ? '' : text;
}

// Keep a readable sentinel in the existing string field when a mixed-version
// result is saved. No schema change, new write path or historical data migration.
export function storedFeedbackText(value, maxChars) {
    return (feedbackText(value) || UNAVAILABLE_FEEDBACK_TEXT).slice(0, maxChars);
}

export function hasUnreadableFeedback(fb) {
    if (!fb) return false;
    if (fb.improvements != null && !Array.isArray(fb.improvements)) return true;
    if ((fb.improvements || []).some((v) => !feedbackText(v))) return true;
    if (fb.criteria != null && !Array.isArray(fb.criteria)) return true;
    return (fb.criteria || []).some((c) => !c || typeof c !== 'object' || Array.isArray(c)
        || ['name', 'comment', 'evidenceFromEssay'].some((key) => c[key] != null && c[key] !== '' && !feedbackText(c[key])));
}
